var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8818 32L29.6088 23H24.9998V6H22.9998V23H18.1548L23.8818 32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10V12H38V40H10V12H18V10H8V42H40V10H30Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8818 32L29.6088 23H24.9998V6H22.9998V23H18.1548L23.8818 32Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10V12H38V40H10V12H18V10H8V42H40V10H30Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/download.21648881706a96a6570e00b402bf1060.svg";